module.exports = __webpack_public_path__ + "static/img/animales_41.e480bc01.png";